<template>
  <div id="navbar">
    <b-navbar toggleable="md" type="light" variant="light">
      <!-- XXX: does it need to be a property at all? -->
      <!-- FIXME: pass HTML through 'title' property to make this component more reusable. -->
      <!--
      <b-navbar-brand tag="h1" v-html="title" class="mb-0"></b-navbar-brand>
      -->
      <b-navbar-brand class="d-none d-md-block" target="_blank" href="https://www.davey.com/">
        <img class="d-none d-md-block" height="50" :src="resolve_img_url(davey)" alt="Davey Tree">
      </b-navbar-brand>

      <b-navbar-nav>
        <b-navbar-brand tag="h1" class="mb-0">
          <span class="title-wrapper"><span class="d-none d-md-inline">Future </span><span class="d-none d-lg-inline">Plant</span> Hardiness Zones</span>
          <a href="https://tools.daveyinstitute.com" target="_blank">tools.daveyinstitute.com</a>
        </b-navbar-brand>
      </b-navbar-nav>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-brand class="d-sm-block d-md-none" target="_blank" href="https://www.davey.com/">
          <img height="50" :src="resolve_img_url(davey)" alt="Davey Tree">
        </b-navbar-brand>
        <b-navbar-brand class="ml-sm-0 ml-md-auto" target="_blank" href="https://www.arborday.org/">
          <img :src="resolve_img_url(arborday)" alt="Arbor Day Foundation">
        </b-navbar-brand>
      </b-collapse>

    </b-navbar>
  </div>
</template>

<script>
  export default {
    name: 'navbar',
    props:{
      title: String,
      davey: String,
      arborday: String
    },
    methods:{
      resolve_img_url: function (file_name) {
        let images = require.context('../assets/', false, /\.png$|\.jpg$/)
        return images('./' + file_name)
      },
    },
  }
</script>

<style scoped lang="scss">
  #navbar {
    .navbar {
      margin: 0 -1rem !important;

      &.navbar-light {
        a {
          font-size: 0.9rem;
          line-height: 1rem;
        }
      }

      .navbar-brand {
        .title-wrapper {
          font-size: 2rem;
          line-height: 2rem;
        }

        &:has(.title-wrapper) {
          display: flex;
          flex-direction: column;
          transform: translateY(8px);
        }
      }
    }
  }
</style>
